declare const version: string;
export const APP_VERSION = version;
